<div class="ui-g import-settings">
  <div class="ui-g-12">
    <div class="ui-g-4">
      <div class="ui-g-4">
        <label for="firstRow">First row</label>
      </div>
      <div class="ui-g-8">
        <p-spinner inputId="firstRow" [(ngModel)]="firstRow" [min]="0"></p-spinner>
      </div>
    </div>
    <div class="ui-g-4" *ngIf="maxErrorsCount !== null">
      <div class="ui-g-4">
        <label for="maxErrorsCount">Max errors count</label>
      </div>
      <div class="ui-g-8">
        <p-spinner inputId="maxErrorsCount" [(ngModel)]="maxErrorsCount" [min]="0"></p-spinner>
      </div>
    </div>
  </div>
  <div class="ui-g-12">
    <p-panel
      header="Show/Hide Configuration"
      [toggleable]="true"
      [collapsed]="columnDefinitions.length > 5 ? true : false"
    >
      <p-table
        [value]="columnDefinitions"
        selectionMode="single"
        [(selection)]="selectedDef"
        [immutable]="false"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="orderNumber">Order Number</th>
            <th pSortableColumn="targetFieldName">Target Field name</th>
            <th pSortableColumn="type">Type</th>
            <th pSortableColumn="isAllowNulls">IsAllowNulls</th>
            <th pSortableColumn="defaultValue">Default Value</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td>{{ item.orderNumber }}</td>
            <td>{{ item.targetFieldName }}</td>
            <td>
              <span>{{ getCellDataTypeName(item.type) }}</span>
            </td>
            <td>{{ item.isAllowNulls }}</td>
            <td>{{ item.defaultValue }}</td>
          </tr>
        </ng-template>
      </p-table>
      <!--- DEPRECATED
      <p-dataTabl [value]="columnDefinitions" selectionMode="single" [(selection)]="selectedDef" [immutable]="false">
          <p-column header="Order Number" field="orderNumber" sortable="tue"></p-column>
          <p-column header="Target field name" field="targetFieldName"></p-column>
          <p-column header="Type" field="type">
              <ng-template let-def="rowData" pTemplate="body">
                  <span>{{getCellDataTypeName(def.type)}}</span>
              </ng-template>
          </p-column>
          <p-column header="IsAllowNulls" field="isAllowNulls"></p-column>
          <p-column header="Default value" field="defaultValue"></p-column>
      </p-dataTable>
      --->
    </p-panel>
  </div>
  <div class="ui-g-12">
    <button
      type="button"
      class="btn-to-right"
      pButton
      (click)="cancel()"
      icon="fa ui-icon-close"
      label="Cancel"
    ></button>
    <button
      type="button"
      class="ui-button-danger btn-to-right"
      pButton
      (click)="deleteDef(selectedDef)"
      icon="fa ui-icon-trash"
      label="Delete"
      [disabled]="!selectedDef"
    ></button>
    <button
      type="button"
      class="btn-to-right"
      pButton
      (click)="editDef(selectedDef)"
      icon="fa ui-icon-edit"
      label="Edit"
      [disabled]="!selectedDef"
    ></button>
    <button
      type="button"
      class="btn-to-right"
      pButton
      (click)="addDef()"
      icon="fa ui-icon-add"
      label="Add"
    ></button>
  </div>
</div>

<p-dialog
  [(visible)]="dialogIsVisible"
  [modal]="true"
  [style]="{ width: '400px' }"
  [contentStyle]="{ overflow: 'visible' }"
  (onHide)="finishEdit()"
>
  <p-header>
    <span *ngIf="editingMode">{{
      editingMode === 'add'
        ? 'Add column definition'
        : 'Edit column definition [' + originalDef.orderNumber + ']'
    }}</span>
  </p-header>

  <div class="ui-g" *ngIf="editingDef">
    <div class="ui-g-12">
      <div class="ui-g-4">
        <label for="orderNumber">Order number</label>
      </div>
      <div class="ui-g-8">
        <p-spinner
          inputId="orderNumber"
          [(ngModel)]="editingDef.orderNumber"
          [min]="1"
          [max]="columnDefinitions.length + (editingMode === 'add' ? 1 : 0)"
        ></p-spinner>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-4">
        <label for="targetFieldName">Target field name</label>
      </div>
      <div class="ui-g-8">
        <input
          pInputText
          id="targetFieldName"
          [(ngModel)]="editingDef.targetFieldName"
          class="filterControl"
        />
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-4">
        <label for="type">Type</label>
      </div>
      <div class="ui-g-8">
        <p-dropdown
          inputId="type"
          [options]="dataTypes"
          [(ngModel)]="editingDef.type"
          [dataKey]="value"
          [autoWidth]="false"
          [style]="{ width: '75%' }"
        >
        </p-dropdown>
      </div>
    </div>
    <div class="ui-g-12" *ngIf="editingDef.typeInfo && editingDef.type == 1">
      <div class="ui-g-4">
        <label for="typeInfo_min">Min</label>
      </div>
      <div class="ui-g-8">
        <p-spinner
          inputId="typeInfo_min"
          [(ngModel)]="editingDef.typeInfo.min"
          [min]="0"
          [max]="editingDef.typeInfo.max - 0.01"
          step="0.01"
        ></p-spinner>
      </div>
    </div>
    <div class="ui-g-12" *ngIf="editingDef.typeInfo && editingDef.type == 1">
      <div class="ui-g-4">
        <label for="typeInfo_max">Max</label>
      </div>
      <div class="ui-g-8">
        <p-spinner
          inputId="typeInfo_max"
          [(ngModel)]="editingDef.typeInfo.max"
          [min]="editingDef.typeInfo.min + 0.01"
          [max]="100"
          step="0.01"
        ></p-spinner>
      </div>
    </div>

    <div class="ui-g-12" *ngIf="editingDef.typeInfo && editingDef.type == 0">
      <div class="ui-g-4">
        <label for="typeInfo_maxLen">Max String Length</label>
      </div>
      <div class="ui-g-8">
        <p-spinner
          inputId="typeInfo_maxLen"
          [(ngModel)]="editingDef.typeInfo.maxLength"
          [min]="editingDef.typeInfo.max - 0.01"
          [max]="100"
          step="0.01"
        ></p-spinner>
      </div>
    </div>

    <div class="ui-g-12" *ngIf="editingDef.typeInfo && editingDef.type == 2">
      <div class="ui-g-4">
        <label for="typeInfo_dateFormats">Date formats</label>
      </div>
      <div class="ui-g-8">
        <input
          pInputText
          id="typeInfo_dateFormats"
          [(ngModel)]="editingDef.typeInfo.dateFormats"
          class="filterControl"
        />
      </div>
    </div>
    <div class="ui-g-12" *ngIf="editingDef.typeInfo && editingDef.type == 5">
      <div class="ui-g-4">
        <label for="typeInfo_customValidation">Custom validation</label>
      </div>
      <div class="ui-g-8">
        <p-dropdown
          inputId="typeInfo_customValidation"
          [options]="customValidationTypes"
          [(ngModel)]="editingDef.typeInfo.customValidation"
          [dataKey]="value"
          [autoWidth]="false"
          [style]="{ width: '75%' }"
        >
        </p-dropdown>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-4"></div>
      <div class="ui-g-8">
        <p-checkbox
          inputId="isAllowNulls"
          label="IsAllowNulls"
          binary="true"
          [(ngModel)]="editingDef.isAllowNulls"
        ></p-checkbox>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-4">
        <label for="defaultValue">Default value</label>
      </div>
      <div class="ui-g-8">
        <input
          pInputText
          id="defaultValue"
          [(ngModel)]="editingDef.defaultValue"
          class="filterControl"
        />
      </div>
    </div>
  </div>
  <p-footer>
    <button
      type="button"
      pButton
      icon="fa ui-icon-close"
      class="ui-button-secondary"
      (click)="dialogIsVisible = false"
      label="Cancel"
    ></button>

    <button
      type="button"
      pButton
      class="ui-button-primary"
      icon="fa ui-icon-check"
      (click)="commitEdit()"
      [label]="editingMode === 'add' ? 'Add' : 'Save'"
    ></button>
  </p-footer>
</p-dialog>

<p-confirmDialog
  header="Confirmation"
  icon="fa ui-icon-question"
  [style]="{ width: '425px' }"
  acceptLabel="Save"
  rejectLabel="Cancel"
></p-confirmDialog>
